import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import './SectionDropZone.scss'

export interface SectionDropZoneProps {
  /** Gap index — determines where in the segment order this zone sits. */
  index: number
  /** Whether a section drag is currently active. */
  active: boolean
}

/**
 * Invisible drop target between segments for section reordering.
 * Expands instantly to 32px when a section drag is active.
 */
export const SectionDropZone: React.FC<SectionDropZoneProps> = ({ index, active }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `section-gap::${index}`,
    disabled: !active,
  })

  return (
    <div
      ref={setNodeRef}
      data-drop-zone-idx={index}
      className={`section-drop-zone${active ? ' section-drop-zone--active' : ''}${isOver ? ' section-drop-zone--over' : ''}`}
    />
  )
}
